import moment from 'moment-timezone'
import { Maybe } from 'types/graphqlTypes'
import { FORMATS } from 'constants/datetime'

/**
 * @example getFormattedTime('2020-01-01T00:00:00.000Z', 'America/New_York')
 */
export const getFormattedTime = (time: Maybe<string>, timezone: string): string | null => {
  if (!time) {
    return null
  }

  return moment(time).tz(timezone).format(FORMATS.datetimeShort12H)
}
